import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Image, { IImage } from '../../../Image'
import RichText, { IRichText } from '../../../RichText'
import { useTheme } from '@mui/material/styles'
import TextComponent from '../../../Text'
import CardComponent from '../../../Card'
import CallToAction from '../../../CallToAction'
import { ContentfulToComponent, ContentfulToComponentProps } from '../../../RichText/types'

type TextProps = { text: IRichText }
type ImageProps = { image: IImage }
type Column = TextProps | ImageProps
type DiscriminatedColumn = { __typename: 'HelpUniverseComponentText' | 'HelpUniverseComponentImage' } & Column
const contactcomponentMap: Partial<ContentfulToComponent> = {
  'HelpUniverseComponentText': TextComponent,
  'HelpUniverseComponentCard': CardComponent,
  'HelpUniverseComponentCta': CallToAction,
} as const

// Define propsMap for RichText
const propsMap: Partial<ContentfulToComponentProps> = {
  HelpUniverseComponentText: <TextComponentProps,>(props: TextComponentProps) => ({
    ...(props as unknown as TextComponentProps),
  }),
  HelpUniverseComponentCard: <CardProps,>(props: CardProps) => ({
    ...(props as unknown as CardProps),
  }),
  HelpUniverseComponentCta: <CallToActionType,>(props: CallToActionType) => ({
    ...(props as unknown as CallToActionType),
  }),
} as const

const ContactSectionComponent = () => {
  const { palette } = useTheme()
  const styles = {
    container: {
      paddingBottom: '3rem',
      paddingTop: '3rem',
      '.MuiTypography-h6': {
        color: palette.primary.light,
      },
    },
  }
  const {
    helpUniverseLayoutColumns: { numberOfColumns, columnContent },
  } = useStaticQuery(graphql`
    query {
      helpUniverseLayoutColumns(contentful_id: { eq: "3DwEBf4qEmFzbXL7RU3vD1" }) {
        numberOfColumns
        columnContent {
          __typename
          ... on HelpUniverseComponentText {
            ...TEXT
          }
          ... on HelpUniverseComponentImage {
            image {
              file {
                contentType
                fileName
                url
              }
              description
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
      }
    }
  `)

  const itemWidth = 12 / (numberOfColumns ?? 1)

  return (
    <Box sx={{ backgroundColor: palette.info.contrastText }}>
      <Container maxWidth="lg" sx={styles.container}>
        <Grid container spacing={3}>
          {columnContent?.map(({ __typename, ...rest }: DiscriminatedColumn, index: number) => (
            <Grid
              key={index}
              xs={12}
              md={itemWidth}
              item
              sx={__typename === 'HelpUniverseComponentImage' ? { textAlign: 'center' } : {}}
            >
              {(() => {
                switch (__typename) {
                  case 'HelpUniverseComponentImage':
                    return <Image {...(rest as ImageProps).image} />
                  case 'HelpUniverseComponentText':
                    return (
                      <RichText
                        {...(rest as TextProps).text}
                        componentMap={contactcomponentMap as ContentfulToComponent}
                        propsMap={propsMap as ContentfulToComponentProps}
                      />
                    )
                  default:
                    return <></>
                }
              })()}
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default ContactSectionComponent
